module.exports = __webpack_public_path__ + "img/ws.c2296c33.svg";